import { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.scss';
//import { useClearCache } from 'shared/clear-cache';/* Bug #469 @Author Jithin Kuriakose @Date 30 June 2021 */
import ContextProvidersComponent from 'components-contexts';
import MainLayout from './layouts'
import ClientRouter from 'client/client-router';
import FcmReceiver from './firebase';
import { ENABLE_FCM_WEB } from 'config/FeatureFlag';
import { Modal, RootState } from 'components';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { connect } from "react-redux";
import { detectMobileApp } from 'shared/utils/detectDevice';

const AppRouter = (props) => {
    
    const sw = navigator.serviceWorker;
    const isMobileApp = detectMobileApp();
    //const [showUpdateAlert, setShowUpdateAlert] = useState(false);
    
    useEffect(() => {
        //console.log("window.location.hostname ", window.location.hostname)
        if (sw) {
            sw.onmessage = (event) => {
                if (
                    event.data &&
                    event.data.type === "NEW_SERVICE_WORKER_UPDATED" && !isMobileApp
                ) {
                    Modal.info({
                        title: 'New Mandatory Update is Available!',
                        icon: <ExclamationCircleOutlined style={{ color: '#1890ff' }}/>,
                        content: (
                          <div>
                            <p>{`${window?.location?.hostname} needs to restart your browser to complete the mandatory updates.`}</p>
                          </div>
                        ),
                        onOk() {
                            window.location.reload();
                        },
                        onCancel() {
                            
                        },
                        okText: "Restart Now",
                        cancelText: "Later",
                      });
                    //setShowUpdateAlert(true);
                }
            };
        }
    }, [sw]);
    useEffect(() => {
        serviceWorkerRegistration.register();
    }, [props.accessToken]);
    

    return (
        <ContextProvidersComponent>
                <Router> 
                    
                   {ENABLE_FCM_WEB &&<FcmReceiver/>}

                    <MainLayout>
                        <ClientRouter />
                    </MainLayout>
                    {/* <LayoutComponent /> */}
                    {/* <Route render={(props)=> <AppContainer {...props}/>} /> */}
                </Router>
        </ContextProvidersComponent>
    );

}


const mapStateToProps = ({ authentication }: RootState) => ({
    accessToken: authentication.accessToken
  });

export default connect(mapStateToProps, null) (AppRouter);